module.exports = __webpack_public_path__ + "static/img/buttonThree.36cda7bc.png";